<template>
  <BranchRegionReport
      :items="items"
      @updated="onUpdate"
  />
</template>

<script>

import _ from "underscore"
import Moment from "moment";
import {AllowStatistics} from "@/enums/permission";
import ReportService from "@/services/report.service"
import {  LAYOUT_LOADING_START,  LAYOUT_LOADING_STOP,  LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import Mappers from "@/mappers";
import BranchRegionReport from "@/components/report/BranchStatistics/BranchRegionReportComponent.vue";

export default {
  name: "BranchRegionReportView",
  components: {
    BranchRegionReport
  },
  data() {
    return {
      items: []
    }
  },
  computed: {
    isAllowStatistics() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowStatistics
      })
    }
  },
  methods: {
    onUpdate(filters) {
      const {start, end, date, selectedFilters, selectedRegions, isAllClientsSelected, isArchive, clients} = filters;
      if (selectedFilters && selectedFilters.includes(3) && !selectedFilters.includes(2)) {
        selectedFilters.push(2);
      }
      if (selectedRegions && !selectedRegions.includes(1)){
        selectedRegions.push(1)
      }

      this.$store.dispatch(LAYOUT_LOADING_START)
      ReportService.getBranchRegionReport({
        client: this.$store.getters.appActiveClient,
        start: start ? Moment(start, "YYYY-MM-DD") : null,
        end: end ? Moment(end, "YYYY-MM-DD") : null,
        date: date ? Moment(date, "YYYY-MM") : null,
        username: this.$store.getters.appLogin.username,
        selectedFilters: selectedFilters ? selectedFilters : null,
        selectedRegions: selectedRegions ? selectedRegions : null,
        isAllClientsSelected: isAllClientsSelected,
        type: isArchive,
        clients: clients
      })
          .then(response => {
            this.items = _.map(response.data, rvm => {
              return {
                region: Mappers.mapRegion(rvm.Region),
                received: rvm.Received,
                printedForPeriodNormal: rvm.PrintedForPeriodNormal,
                restForPeriodEnd: selectedFilters ?
                    (rvm.Received !== null && rvm.PrintedForPeriodNormal !== null ?
                        (rvm.Received - rvm.PrintedForPeriodNormal) : null) : null,
                deletedFromPostPackageCount: rvm.DeletedFromPostPackageCount,
                postPackedForPeriod: rvm.PostPackedForPeriod,
                deliveredFromPacked: rvm.DeliveredFromPacked,
                tryPerform: rvm.TryPerformCount,
                returnedFromPacked: rvm.ReturnedFromPacked,
                postPackedNotPerformed: rvm.PostPackedNotPerformed,
                expiredCount: rvm.ExpiredCount,
                successDeliveredAfterFailedCount: rvm.SuccessDeliveredAfterFailedCount
              }
            })
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    }
  },
  created() {
    if (this.isAllowStatistics) {
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, "Статистика филиалов по регионам")
    }
    else
      this.$router.go(-1)
  }
}
</script>

<style scoped>
</style>
